export const isNonEmptyString = (input: string | null) => {
  return input && input.trim().length > 0
}
